module.exports = __webpack_public_path__ + "static/c4fc4e97a1edc09a7d444017f4161ef993d7b2a7bffe50de592417e8be927bcb-7b45b0021267e01521ff9ba8760fc6e8.png";